export default __webpack_public_path__ + "static/media/twostation2d.2b45344b.png";